module.exports = __webpack_public_path__ + "img/smartphone.1c325263.png";